module.exports = __webpack_public_path__ + "img/curve-4-4.d824573d.svg";